import { memo } from 'react'
import { Tooltip } from '@mui/material'

import { useIsPhone } from 'utils/hook'
import truncateText from 'utils/truncateText'

interface InputLabelProps {
  label?: string
}

function InputLabel({ label }: InputLabelProps): JSX.Element | null {
  if (label === undefined) {
    return null
  }

  const isPhone = useIsPhone()
  const labelMaxLength = isPhone ? 45 : 60

  if (label.length < labelMaxLength) {
    return <>{label}</>
  }

  return (
    <Tooltip title={label} enterTouchDelay={0}>
      <span>{truncateText(label, labelMaxLength)}</span>
    </Tooltip>
  )
}

export default memo(InputLabel)
